import { cn } from 'components/UI/cn'

interface FormatBadgeProps {
  plainText: boolean
  className?: string
}

/**
 * Pill that shows whether a campaign sends as plain text or HTML. Surfaced
 * next to the body editor and previews so users know what recipients will
 * actually see.
 */
export function FormatBadge({ plainText, className }: FormatBadgeProps) {
  return (
    <span
      className={cn(
        'inline-block rounded px-1.5 py-0.5 text-xxs font-medium',
        plainText
          ? 'bg-surface-alt text-fg-secondary'
          : 'bg-warning-bg text-warning',
        className
      )}
      title={
        plainText
          ? 'This campaign sends as plain text. Bold, italic, color, and other formatting will not render to recipients.'
          : 'This campaign sends as HTML. Formatting will render — use plain text for cold outreach to maximize deliverability.'
      }
    >
      {plainText ? 'Plain text' : 'HTML'}
    </span>
  )
}
